'use client';
import { onEnter } from '@susu/custom-made/utils/utils';
import cn from 'classnames';

import styles from './textInput.module.scss';

export enum TextBorderType {
  Round = 'round',
  Square = 'square',
}

export default function TextInput({
  placeholder,
  onChange,
  textValue,
  inputTestId,
  maxLength,
  charCounter,
  textBorderType = TextBorderType.Round,
  isSearchIcon,
  errorMessage,
  hasClearBtn = true,
}: Readonly<{
  placeholder?: string;
  onChange: (searchText: string) => void;
  textValue: string;
  inputTestId?: string;
  maxLength?: number;
  charCounter?: string;
  textBorderType?: TextBorderType;
  isSearchIcon?: boolean;
  errorMessage?: string;
  hasClearBtn?: boolean;
}>) {
  const onTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div
      className={cn(styles.inputContainer, styles[textBorderType], {
        [styles.searchIcon]: isSearchIcon,
        [styles.charCounter]: charCounter,
        [styles.error]: errorMessage,
      })}
    >
      <input
        className={styles.input}
        data-test-id={inputTestId}
        type="text"
        placeholder={placeholder}
        onChange={onTextChange}
        value={textValue}
        maxLength={maxLength}
      />
      {hasClearBtn && !charCounter && textValue.length > 0 && (
        <div
          className={styles.clearIconContainer}
          onClick={() => {
            onChange('');
          }}
          onKeyDown={e => {
            onEnter(e, () => {
              onChange('');
            });
          }}
        >
          <div className={styles.clearIcon} data-test-id="clear-input-btn">
            <i className="susu-icons" translate="no">
              close
            </i>
          </div>
        </div>
      )}
      {charCounter && <span className={styles.charCounter}>{charCounter}</span>}
      {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
    </div>
  );
}
